import { connect } from 'react-redux';
import { setToggled, getToggled } from '../../../modules/Filters';
import { getSearchType } from '../../../modules/Settings';
import MobileToolbar from './MobileToolbar';

const mapStateToProps = state => {
  return {
    mobileFiltersActive: getToggled(state),
    searchType: getSearchType(state)
  };
};

const mapDispatchToProps = dispatch => ({
  toggleFilters: () => dispatch(setToggled())
});

const MobileToolbarContainer = connect(mapStateToProps, mapDispatchToProps)(MobileToolbar);

export default MobileToolbarContainer;
